Ext.define('SA.view.ToggleSwitch', {
    alias: 'widget.sa-toggle-switch',
    extend: 'SA.view.CheckField',

    activeCls: null,
    baseCls: 'sa-toggle-switch',
    hoverCls: null,

    clickHandlers: {
        '.sa-toggle-switch-button': function() {
            var checked = !this.isChecked();

            this.setChecked(checked);
        },

        '.sa-toggle-switch-label-left': function() {
            this.setChecked(false);
        },

        '.sa-toggle-switch-label-right': function() {
            this.setChecked(true);
        }
    },

    renderTpl: [
        '<tpl if="leftText">',
            '<span aria-hidden="true" class="sa-toggle-switch-label sa-toggle-switch-label-left">{leftText}</span>',
        '</tpl>',
        '<div aria-checked="{checked}" class="sa-check-field-button sa-toggle-switch-button" role="switch" tabindex="0"></div>',
        '<tpl if="rightText">',
            '<span aria-hidden="true" class="sa-toggle-switch-label sa-toggle-switch-label-right">{rightText}</span>',
        '</tpl>'
    ],

    afterRender() {
        this.callParent();

        this.button = this.el.down('.sa-toggle-switch-button');
    },

    getTemplateArgs() {
        return {
            checked: this.checked,
            leftText: this.leftText,
            rightText: this.rightText
        };
    }
});
